export default __webpack_public_path__ + "static/media/MicrosoftTeams-image-(4)-375X550.829bc85f.png";